import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_super/super/_layout")({
  component: SuperLayout,
});

function SuperLayout() {
  return <Outlet />;
}
